export enum LiabilitiesEnum {
	'planning_breaches' = 'Breaches of planning permission conditions',
	'consent_breaches' = 'Breaches of building regulation consents conditions',
	'unfinished_work' = 'Unfinished work',
	'no_consent_work' = 'Work that does not have all necessary consents',
	'planning_issues' = 'Unresolved planning or building control issues',
}
